export default {
  saveLoggedInUser(state, user) {
    state.auth = user;
  },
};
